// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fieldset {
    border:none;
    display: flex;
    flex-direction: column;
}

fieldset input {
    color: var(--darker-text);
    padding: 0.25rem 0.4rem;
    font-size: .9rem;
    border-radius: 4px;
    border: none;
    margin: 0.2rem;
    outline: none;
    line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/form/form.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB","sourcesContent":["fieldset {\n    border:none;\n    display: flex;\n    flex-direction: column;\n}\n\nfieldset input {\n    color: var(--darker-text);\n    padding: 0.25rem 0.4rem;\n    font-size: .9rem;\n    border-radius: 4px;\n    border: none;\n    margin: 0.2rem;\n    outline: none;\n    line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
